type Props = {
  collapsed: boolean;
  onToggle: () => void;
};

/** Classic 3-line menu icon — sidebar collapse / expand */
export default function SidebarToggle({ collapsed, onToggle }: Props) {
  const label = collapsed ? 'Expand sidebar' : 'Collapse sidebar';

  return (
    <button
      type="button"
      onClick={onToggle}
      className="sidebar-collapse-btn"
      title={label}
      aria-label={label}
      aria-expanded={!collapsed}
    >
      <span className={`sidebar-collapse-icon ${collapsed ? 'sidebar-collapse-icon--expand' : ''}`} aria-hidden>
        <span className="sidebar-collapse-icon__line" />
        <span className="sidebar-collapse-icon__line" />
        <span className="sidebar-collapse-icon__line" />
      </span>
    </button>
  );
}
